module.exports = __webpack_public_path__ + "img/vip1.084ab0a5.png";